// ** React Imports
import React, { useState } from 'react'

// ** Utils and Child Imports
import FormDialog from './ExportDialogComponent'
import { ExportOptionConfigType } from 'src/lib/types/exports'
import { Button } from '@mui/material'
import { ArrowRight } from 'react-feather'
import { ParentComponentTypes } from 'src/lib/types/activityLogTypes'

interface ExportComponentProps {
  isExportDisabled: boolean
  exportOptionData: ExportOptionConfigType[]
  titleText: string
  jobButtonText: string
  dialogButtonText: string
  globalEndDate?: string | Date
  globalStartDate?: string | Date
  hideRadioButtons: boolean
  parentComponent?: ParentComponentTypes | undefined
}

const ExportComponent: React.FC<ExportComponentProps> = ({
  isExportDisabled,
  exportOptionData,
  globalEndDate,
  globalStartDate,
  titleText,
  jobButtonText,
  dialogButtonText,
  hideRadioButtons = false,
  parentComponent = ParentComponentTypes.DISCOUNTS
}) => {
  const [isOpenFormDialog, setOpenFormDialog] = useState<boolean>(false)

  return (
    <>
      <Button
        id='export-button'
        variant='outlined'
        size='medium'
        disabled={isExportDisabled}
        style={{ whiteSpace: 'nowrap', height: 36, background: '#FFFFFF' }}
        onClick={() => setOpenFormDialog(true)}
        endIcon={<ArrowRight className='w-4 h-4' id='export-button-icon' />}
      >
        {dialogButtonText}
      </Button>

      <FormDialog
        underInputText={'A download link will be sent to this email address.'}
        emailInputLabel={'Send to'}
        emailInputPlaceholder={'Enter email address'}
        exportCategoryData={exportOptionData ?? []}
        isOpen={isOpenFormDialog}
        setIsDialogOpen={setOpenFormDialog}
        titleText={titleText}
        jobButtonColor={'primary'}
        jobButtonText={jobButtonText}
        cancelButtonColor={'secondary'}
        cancelButtonText={'Cancel'}
        startDateLabel={'Start date'}
        endDateLabel={'End date'}
        globalEndDate={globalEndDate}
        globalStartDate={globalStartDate}
        hideRadioButtons={hideRadioButtons}
        hideDateRange={false}
        parentComponent={parentComponent}
      />
    </>
  )
}

export default ExportComponent
